import { ActionTree } from 'vuex';
import { RecommendationsState } from '../../models';
import { RootStoreState } from '../store.interfaces';
import { ClearRecommendationsAction } from './actions/clear-recommendations.action';
import { GetRecommendationsAction } from './actions/get-recommendations.action';

export const RECOMMENDATIONS_ACTIONS: ActionTree<RecommendationsState, RootStoreState> = {
  ...new ClearRecommendationsAction().actions,
  ...new GetRecommendationsAction().actions
};
